import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, effect, ElementRef, inject, ViewChild } from '@angular/core';
import { IconModule } from '@iota/iota-ui-components';
import { IndexedMagicSearchRow } from '../../models/magic-search.model';
import { MagicSearchService } from '../../services/magic-search.service';
import { MagicSearchResultRowComponent } from '../magic-search-result-row/magic-search-result-row.component';

@Component({
    selector: 'app-magic-search-overlay',
    standalone: true,
    imports: [CommonModule, IconModule, MagicSearchResultRowComponent],
    templateUrl: './magic-search-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MagicSearchOverlayComponent implements AfterViewInit {
    readonly service = inject(MagicSearchService);
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    @ViewChild('searchInput') private readonly searchInput!: ElementRef<HTMLInputElement>;

    constructor() {
        effect(() => {
            const index = this.service.selectedIndex();
            queueMicrotask(() => {
                const selected = this.host.nativeElement.querySelector(`[data-row-index="${index}"]`);
                selected?.scrollIntoView({ block: 'nearest' });
            });
        });
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    onInput(event: Event): void {
        this.service.setQuery((event.target as HTMLInputElement).value);
    }

    onKeydown(event: KeyboardEvent): void {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.service.moveSelection(1);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.service.moveSelection(-1);
                break;
            case 'Enter':
                event.preventDefault();
                this.service.navigateSelected();
                break;
        }
    }

    trackByRowKey(_index: number, row: IndexedMagicSearchRow): string {
        return row.key;
    }
}
